import calcAge from "@/lib/calcAge";
export default function yupAgeValidate(y) {
  y.addMethod(y.string, "age", function (validAge) {
    return this.test("age", "".concat(validAge, "\u6B73\u672A\u6E80\u306F\u767B\u9332\u3067\u304D\u307E\u305B\u3093\u3002"), function (value) {
      var age = calcAge(value);
      return age >= validAge;
    });
  });
}